import { Container, Typography, makeStyles } from '@material-ui/core';
import { ReactNode } from 'react';

const useTitleStyles = makeStyles((theme) => ({
  root: {
    color:
      theme.palette.type === 'light' ? theme.palette.common.midBlue : undefined,
    fontSize: theme.typography.pxToRem(34),
    marginBottom: 25,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(55),
      marginBottom: 65,
      marginTop: 50,
    },
  },
}));

interface TitleProps {
  children: string;
}

export function Title({ children }: TitleProps) {
  const classes = useTitleStyles();

  return (
    <Typography className={classes.root} align="center" variant="h1">
      {children}
    </Typography>
  );
}

const useSectionTitleStyles = makeStyles((theme) => ({
  root: {
    color:
      theme.palette.type === 'light' ? theme.palette.common.midBlue : undefined,
    fontSize: theme.typography.pxToRem(28),
    marginBottom: 24,
    marginTop: 24,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(48),
    },
  },
}));

interface SectionTitleProps {
  children: string;
}

export function SectionTitle({ children }: SectionTitleProps) {
  const classes = useSectionTitleStyles();

  return (
    <Typography className={classes.root} align="center" variant="h2">
      {children}
    </Typography>
  );
}

interface WrapperProps {
  children: ReactNode;
}

const useWrapperStyles = makeStyles((theme) => ({
  page:
    theme.palette.type === 'light'
      ? {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.common.midBlue,
          display: 'flow-root',
          minHeight: 'calc(100vh - 64px)',
        }
      : {},
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginBottom: 24,
  },
}));

export function Wrapper({ children }: WrapperProps) {
  const classes = useWrapperStyles();

  return (
    <div className={classes.page}>
      <Container maxWidth="lg">
        <div className={classes.root}>{children}</div>
      </Container>
    </div>
  );
}
